import { FormEvent, ReactNode } from 'react';

import { Column, Button } from 'components/Blocks';

interface FormWrapperProps {
  loading: boolean;
  buttonText: string;
  onSubmit: (event: FormEvent) => Promise<void> | void;
  children: ReactNode;
}

export function FormWrapper({ onSubmit, loading, buttonText, children }: FormWrapperProps) {
  return (
    <Column as="form" className="text-center" gap="6" onSubmit={onSubmit}>
      {children}

      <Button type="submit" loading={loading} className="h-8">
        {buttonText}
      </Button>
    </Column>
  );
}
